import { createSettingsParamsWithDefaults } from '../PackagePicker/settingsParams';

export default createSettingsParamsWithDefaults({
  showPageTitle: false,
  wereNewSettingsOpened: true,
});
